<template>
  <md-dialog :md-active="open" class="modal-close">
    <span
class="material-icons close text-right"
@click="closeModal"
      >close</span
    >
    <div class="body-modal-course">
      <md-dialog-title>NUEVO CURSO</md-dialog-title>

      <md-dialog-content class="mt-2">
        <span>
          Ingrese el nombre del curso que desea crear.</span
        ></md-dialog-content
      >

      <md-dialog-content>
        <md-field>
          <div class="md-field md-theme-default md-has-placeholder pt-0">
            <md-input v-model="value" placeholder="NUEVO CURSO"></md-input>
          </div>
        </md-field>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button
          class="md-button md-primary md-theme-default"
          @click="closeModal"
          >CANCELAR
        </md-button>
        <base-button
          :loading="isLoading"
          class="md-primary w-100"
          @click="createCourse"
          >AGREGAR
        </base-button>
      </md-dialog-actions>
    </div>
  </md-dialog>
</template>

<script>
import { CREATE_COURSE } from '../../../../store/actions/course';
import BaseButton from '../../../../components/BaseButton';

export default {
  name: 'CreateCourseDialog',
  components: {
    BaseButton,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close-modal', 'success'],
  data() {
    return {
      isLoading: false,
      value: '',
    };
  },

  computed: {
    open: {
      // getter
      get: function () {
        return this.isOpen;
      },
      // setter
      set: function () {
        this.closeModal();
      },
    },
  },
  mounted() {
    this.value = '';
  },
  methods: {
    closeModal() {
      this.reset();
      this.$emit('close-modal');
    },
    reset() {
      this.value = '';
    },
    createCourse() {
      this.isLoading = true;
      this.$store
        .dispatch(CREATE_COURSE, { name: this.value })
        .then(() => {
          this.isLoading = false;
          this.notify('success', 'Se creo el curso correctamente');
          this.$emit('success');
          this.closeModal();
        })
        .catch(() => {
          this.notify('danger', 'Tenemos problemas para crear el curso');
          this.isLoading = false;
        });
    },
    notify(type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
  },
};
</script>

<style scoped></style>
